import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { AuthService } from "src/app/services/auth.service";

export interface TxDocument {
  internalUnicodeFormat: string;
  html: string;
  pdf: string;
}

@Component({
  selector: "app-txt-control-editior",
  templateUrl: "./txt-control-editor.component.html",
})
export class TxtControlEditorComponent implements OnInit {
  @ViewChild("editorIframe", { static: false })
  editorIframe!: ElementRef<HTMLIFrameElement>;
  @Input() public text: any;
  @Input() public html: any;
  @Input() public header: any;
  @Output() textChange: EventEmitter<void> = new EventEmitter<void>();
  @Input() public noFooter: boolean = false;

  urlTxtEditor!: SafeResourceUrl;

  constructor(
    private authService: AuthService,
    private sanitizer: DomSanitizer
  ) {}


  textChangeCount = 0;
  lastTextChangeAt: Date | null = null;

  private readonly iframeMessageHandler = (event: MessageEvent): void => {
    const iframeWindow =
      this.editorIframe && this.editorIframe.nativeElement
        ? this.editorIframe.nativeElement.contentWindow
        : null;

    if (!iframeWindow || event.source !== iframeWindow) {
      return;
    }

    if (!event.data || event.data.type !== 'text-change') {
      return;
    }

    this.textChangeCount += 1;
    const changedAt =
      event.data.payload && event.data.payload.changedAt
        ? event.data.payload.changedAt
        : Date.now();
    this.lastTextChangeAt = new Date(changedAt);
    console.log(`Text change #${this.textChangeCount} at ${this.lastTextChangeAt.toISOString()}`);
    this.textChange.emit();
  };



  ngOnInit() {
    const rawUrl = this.authService.getTxControlUrl();
    this.urlTxtEditor = this.sanitizer.bypassSecurityTrustResourceUrl(
      rawUrl || ""
    );

    window.addEventListener('message', this.iframeMessageHandler);
  }

  onIframeLoad() {
    const contentWindow =
      this.editorIframe && this.editorIframe.nativeElement
        ? this.editorIframe.nativeElement.contentWindow
        : null;
    if (!contentWindow) {
      return;
    }

    const username = this.authService.getUserName() || "";

    if (this.html) {
      contentWindow.postMessage(
        {
          type: "load-html",
          payload: {
            document: this.html,
            username: username,
          },
        },
        "*"
      );
    } else if (this.text) {
      contentWindow.postMessage(
        {
          type: "load-document",
          payload: {
            document: this.text,
            username: username,
          },
        },
        "*"
      );
    } else if (this.header) {
      contentWindow.postMessage(
        {
          type: "load-empty-document",
          payload: {
            header: this.header,
            username: username,
          },
        },
        "*"
      );
    } else {
      contentWindow.postMessage(
        {
          type: "load-empty-document",
          payload: {
            header: "",
            username: username,
          },
        },
        "*"
      );
    }
  }

  public addTemplate(
    result: string[],
    headerHtml: string,
    footerHtml: string
  ): void {
    const contentWindow =
      this.editorIframe && this.editorIframe.nativeElement
        ? this.editorIframe.nativeElement.contentWindow
        : null;
    if (!contentWindow) {
      return;
    }

    contentWindow.postMessage(
      {
        type: "append-documents",
        payload: {
          templates: result,
          headerHtml: headerHtml,
          footerHtml: footerHtml,
          noFooter: this.noFooter,
        },
      },
      "*"
    );
  }

  getInternalUnicodeFormat(): Promise<string> {
    return new Promise((resolve) => {
      const handler = (event: MessageEvent) => {
        if (event.data.type === 'get-internal-unicode-format') {
          window.removeEventListener('message', handler);
          resolve(event.data.payload.internalUnicodeFormat);
        }
      };

      window.addEventListener('message', handler);

      const contentWindow = this.editorIframe.nativeElement.contentWindow;
      if (contentWindow) {
        contentWindow.postMessage(
          { type: 'get-internal-unicode-format' },
          '*'
        );
      }
    });
  }

  async getDocument(
    headerHtml: string,
    footerHtml: string
  ): Promise<TxDocument> {
    const document = await this.getTxDocument(headerHtml, footerHtml);
    return document;
  }

  private getTxDocument(
    headerHtml: string,
    footerHtml: string
  ): Promise<TxDocument> {
    return new Promise((resolve) => {
      const handler = (event: MessageEvent) => {
        if (event.data.type === "get-document") {
          window.removeEventListener("message", handler); // limpiamos
          resolve(event.data.payload);
        }
      };
      window.addEventListener("message", handler);

      const contentWindow =
        this.editorIframe && this.editorIframe.nativeElement
          ? this.editorIframe.nativeElement.contentWindow
          : null;
      if (!contentWindow) {
        window.removeEventListener("message", handler);
        resolve({
          internalUnicodeFormat: "",
          html: "",
          pdf: "",
        });
        return;
      }

      contentWindow.postMessage(
        {
          type: "get-document",
          payload: {
            headerHtml: headerHtml,
            footerHtml: footerHtml,
            noFooter: this.noFooter,
          },
        },
        "*"
      );
    });
  }
}
